export interface TechnologyGroup {
  title: string;
  icon: string;
  technologies: string[];
}

export const technologyGroups: TechnologyGroup[] = [
  {
    title: "Infrastructure & Network",
    icon: "ri-server-line",
    technologies: [
      "LAN/WAN",
      "Windows Server",
      "VMware/vCenter",
      "Virtualization",
      "Infrastructure Modernization",
      "Server & Collaboration",
      "Migration & Upgrades",
      "Platform Deployment",
      "PowerShell",
      "Cloud Hosting",
      "Enterprise Networks",
    ],
  },
  {
    title: "Database & Data",
    icon: "ri-database-2-line",
    technologies: [
      "Oracle",
      "SQL Server",
      "SQL",
      "Database Administration",
      "Schema Management",
      "Reporting Tools",
      "Data Development",
      "Database Engineering",
      "Data Integrity",
      "SSRS",
    ],
  },
  {
    title: "Application Engineering",
    icon: "ri-code-s-slash-line",
    technologies: [
      "C#",
      ".NET / ASP.NET",
      "MVC",
      "JavaScript",
      "Angular",
      "WebSphere",
      "Python",
      "Full SDLC",
      "Application Maintenance",
      "Platform Engineering",
      "Enterprise Integration",
      "Application Integration",
      "Requirements & Design",
      "Administrative Systems",
    ],
  },
  {
    title: "Microsoft Platforms",
    icon: "ri-window-line",
    technologies: [
      "Power Apps",
      "Power Automate",
      "Power BI",
      "SharePoint",
      "Nintex",
      "Workflow Solutions",
      "Document Libraries",
      "Training & Enablement",
    ],
  },
  {
    title: "Cloud & DevOps",
    icon: "ri-cloud-line",
    technologies: [
      "Microsoft Azure",
      "Azure IaaS / Virtual Machines",
      "Azure PaaS / App Services",
      "Azure Kubernetes (AKS)",
      "Azure Storage & Backup",
      "Hybrid Cloud / Azure Arc",
      "Azure DevOps / CI/CD",
    ],
  },
  {
    title: "Web, Mobile & AI",
    icon: "ri-global-line",
    technologies: [
      "HTML/CSS",
      "CMS",
      "Web Portals",
      "Content Migration",
      "Web Hosting",
      "Intranet / Extranet",
      "Accessibility / WCAG",
      "Mobile Applications",
      "AI-Assisted Engineering",
      "Testing & QA",
      "IT Staff Augmentation",
      "Technical SMEs",
    ],
  },
];